import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Divider, Button, Icon, Popconfirm} from 'antd';
import axios from 'axios';
import LeaveBalanceDialogForm from './LeaveBalanceForm'

const API_HOST_URL = process.env.REACT_APP_API_URL

class MyLeaveBalance extends Component{
  
  state = {
    datalist: [],
    leaveBalance: {},
    visible: false,
    requestType: ''
  }

  componentDidMount(){
    this.fetchData();
  }

  columns = [
    {
      title: 'Leave Type',
      dataIndex: 'leaveType.leaveType',
      key: 'leaveType'
    },
    {
      title: 'Brought Forward',
      dataIndex: 'broughtForward',
      key: 'broughtForward'
    },
    {
      title: 'Total Used',
      dataIndex: 'totalUsed',
      key: 'totalUsed'
    },
    {
      title: 'Leave Balance',
      dataIndex: 'leaveBalance',
      key: 'leaveBalance'
    },
    {
      title: 'Employee',
      dataIndex: 'employee.firstName',
      key: 'employee'
    },
    // {
    //   title: 'Action',
    //   key: 'action',
    //   fixed: 'right',
    //   width: 100,
    //   render: (record) => (
    //     <span>
    //     <a href="javascript:;" onClick={() => this.handleEdit(record)}><Icon type="edit" /></a>

    //     <Divider type="vertical" />

    //     {this.state.datalist.length >= 1
    //       ? (
    //         <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record)}>
    //           <a href="javascript:;"><Icon type="delete" /></a>
    //         </Popconfirm>
    //       ) : null}
    //       </span>
    //   ),

    // }
  ];

  fetchData = () => {
    axios.get(`${API_HOST_URL}/api/leave/leavebalance/?expand=employee&expand=leaveType&employee=${this.props.loggedInEmployee.id}`)
      .then(res => {
        this.setState({
          datalist: res.data
        })
      })
  }

  handleCreate = () => {
    const form = this.formRef.props.form;
    const requestType = this.state.requestType;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      switch( requestType ){
        case 'post':
            return axios.post(`${API_HOST_URL}/api/leave/leavebalance/`, {
              broughtForward: values.broughtForward,
              leaveBalance: values.leaveBalance,
              totalUsed: values.totalUsed,
              leaveType: values.leaveType,
              employee: values.employee
            })
            .then(res => {
              console.log(res)
              form.resetFields();
              this.setState({ visible: false });
              this.fetchData()
        })
            .catch(error => console.err(error));

        case 'put':
            return axios.put(`${API_HOST_URL}/api/leave/leavebalance/${this.state.leaveBalance.id}/`, {
              broughtForward: values.broughtForward,  
              leaveBalance: values.leaveBalance,
              totalUsed: values.totalUsed,
              leaveType: values.leaveType,
              employee: values.employee
            })
                .then(res => {
                  console.log(res)
                  form.resetFields();
                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => console.err(error));
                
        default: return;
      }
    });
  }

  handleEdit = record => {
      this.setState({leaveBalance: record});
      this.showModal('put');
  }

  handleDelete = (record) => {
    const datalist = [...this.state.datalist];

    return axios.delete(`${API_HOST_URL}/api/leave/leavebalance/${record.id}/`)
                .then(res => {
                  console.log(res)

                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => console.err(error));
  }

  showModal = (type) => {
    if( type === 'post'){
      //no data should be passed to dialog form
      this.setState({leaveBalance: {}});
    }

    this.setState({ visible: true, requestType: type });
  }

  handleCancel = () => {
    this.setState({ visible: false });
  }

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  }

    render(){
        return(
          <div>
            {/* <Button type="primary" onClick={() => this.showModal('post')}>Add Leave Balance</Button> */}
            <Table columns={this.columns} dataSource={this.state.datalist} rowKey="id" scroll={{ x: '100%' }}/>

            <LeaveBalanceDialogForm
              wrappedComponentRef={this.saveFormRef}
              visible={this.state.visible}
              onCancel={this.handleCancel}
              onCreate={this.handleCreate}
              data={this.state.leaveBalance}/>
        </div>
        );
    }
}


const mapStateToProps = state => {
    return {
      isAuthenticated: state.token !== null,
      loggedInEmployee: state.loggedInEmployee
    }
  }
  
  export default connect(mapStateToProps, null)(MyLeaveBalance);
  